// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"56a4ea5d","787":"4fa263ff"}[chunkId] + ".chunk.js";
};